import React from 'react';
import { Building2 } from 'lucide-react';

const ClientLogos = () => {
  // Brand partnerships from Infinitum's portfolio
  const brandPartners = [
    { name: 'Sprite', category: 'Beverage' },
    { name: 'Mamaearth', category: 'Beauty' },
    { name: 'Country Delight', category: 'FMCG' },
    { name: 'Happn', category: 'Tech' },
    { name: 'G Square', category: 'Real Estate' },
    { name: 'ASBL', category: 'Construction' },
    { name: 'Paytm', category: 'Fintech' },
    { name: 'Amazon', category: 'E-commerce' },
    { name: 'Flipkart', category: 'E-commerce' },
    { name: 'Swiggy', category: 'Food Tech' },
    { name: 'Zomato', category: 'Food Tech' },
    { name: 'PhonePe', category: 'Fintech' },
    { name: 'Razorpay', category: 'Fintech' },
    { name: 'Byju\'s', category: 'EdTech' },
    { name: 'Unacademy', category: 'EdTech' },
    { name: 'Dream11', category: 'Gaming' },
  ];

  // Create doubled array for infinite scroll
  const allBrands = [...brandPartners, ...brandPartners];

  return (
    <section id="clients" className="py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-[#0077cc] rounded-full text-sm font-medium mb-4">
            <Building2 size={16} />
            Brand Partnerships
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Trusted by <span className="text-[#0077cc]">250+ Brands</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Collaborating with industry leaders for impactful campaigns and content
          </p>
        </div>

        {/* Scrolling Logo Carousel */}
        <div className="relative">
          {/* Gradient Fade Left */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
          
          {/* Gradient Fade Right */}
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />
          
          {/* Scrolling Container */}
          <div className="flex animate-scroll-infinite hover:pause-animation">
            {allBrands.map((brand, index) => (
              <div
                key={`brand-${index}`}
                className="flex-shrink-0 mx-6 px-8 py-4 bg-white rounded-xl border border-gray-200 hover:border-[#0077cc] hover:shadow-lg transition-all duration-300 group"
                data-testid={`brand-logo-${index}`}
              >
                <div className="flex flex-col items-center justify-center min-w-[120px]">
                  {/* Brand Name as Logo */}
                  <span className="text-xl font-bold text-gray-400 group-hover:text-[#0077cc] transition-colors tracking-tight">
                    {brand.name}
                  </span>
                  <span className="text-xs text-gray-400 mt-1">
                    {brand.category}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Second Row - Reverse Direction */}
        <div className="relative mt-6">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />
          
          <div className="flex animate-scroll-infinite-reverse hover:pause-animation">
            {[...allBrands].reverse().map((brand, index) => (
              <div
                key={`brand-rev-${index}`}
                className="flex-shrink-0 mx-6 px-8 py-4 bg-white rounded-xl border border-gray-200 hover:border-[#0077cc] hover:shadow-lg transition-all duration-300 group"
              >
                <div className="flex flex-col items-center justify-center min-w-[120px]">
                  <span className="text-xl font-bold text-gray-400 group-hover:text-[#0077cc] transition-colors tracking-tight">
                    {brand.name}
                  </span>
                  <span className="text-xs text-gray-400 mt-1">
                    {brand.category}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mt-16">
          <div className="text-center p-6 bg-white rounded-2xl border border-gray-200">
            <div className="text-3xl font-bold text-[#0077cc] mb-1">250+</div>
            <div className="text-sm text-gray-600">Brand Partners</div>
          </div>
          <div className="text-center p-6 bg-white rounded-2xl border border-gray-200">
            <div className="text-3xl font-bold text-[#0077cc] mb-1">500+</div>
            <div className="text-sm text-gray-600">Campaigns</div>
          </div>
          <div className="text-center p-6 bg-white rounded-2xl border border-gray-200">
            <div className="text-3xl font-bold text-[#0077cc] mb-1">10B+</div>
            <div className="text-sm text-gray-600">Impressions</div>
          </div>
          <div className="text-center p-6 bg-white rounded-2xl border border-gray-200">
            <div className="text-3xl font-bold text-[#0077cc] mb-1">50+</div>
            <div className="text-sm text-gray-600">Industries</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
